// HeroSection.tsx
import React from 'react';

interface HeroSectionProps {
  sectionRef: React.RefObject<HTMLDivElement>;
}

const HeroSection: React.FC<HeroSectionProps> = ({ sectionRef }) => {
  return (
    <section className="hero-section">
      <div className="content-container" ref={sectionRef}>
        <div className="content-text">
          <h1 className="display-4">Smart CrowdFunding Platform!</h1>
          <p className="lead typing-text">Potential To Turn your $5 once off upto $1 Million Again And Again</p>
          <p className='join-text'>Join The Fastest Growing Crowdfunding Community.</p>
          <button className="register-button-content">Register Now</button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;